// extracted by mini-css-extract-plugin
export default {"layout":"AdminView_layout__dkq88","button":"AdminView_button__4XDOv"};